/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Dec5Inputs */

const id_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Desember`)
};

const ms_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Disember`)
};

const da_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. december`)
};

const de_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Dezember`)
};

const en_us2_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`December 5`)
};

const es_es2_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 de diciembre`)
};

const es_mx2_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 de diciembre`)
};

const fil_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disyembre 5`)
};

const fr_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 décembre`)
};

const it_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 dicembre`)
};

const hu_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`december 5.`)
};

const nl_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 december`)
};

const no_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. desember`)
};

const pl_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 grudnia`)
};

const pt_br2_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 de dezembro`)
};

const pt_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 de dezembro`)
};

const ro_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 decembrie`)
};

const fi_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. joulukuuta`)
};

const sv_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 december`)
};

const vi_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 tháng 12`)
};

const tr_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Aralık`)
};

const cs_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. prosince`)
};

const bg_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 декември`)
};

const ru_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 декабря 2024 г.`)
};

const uk_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 грудня`)
};

const ar_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 ديسمبر`)
};

const hi_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 दिसंबर`)
};

const th_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 ธันวาคม`)
};

const ja_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12月5日`)
};

const zh_cn2_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12月5日`)
};

const zh_hant1_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12月5日`)
};

const ko_misc_posts_dec5 = /** @type {(inputs: Misc_Posts_Dec5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12월 5일`)
};

/**
* | output |
* | --- |
* | "December 5" |
*
* @param {Misc_Posts_Dec5Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_dec5 = /** @type {((inputs?: Misc_Posts_Dec5Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Dec5Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_dec5(inputs)
	if (locale === "ms") return ms_misc_posts_dec5(inputs)
	if (locale === "da") return da_misc_posts_dec5(inputs)
	if (locale === "de") return de_misc_posts_dec5(inputs)
	if (locale === "en-US") return en_us2_misc_posts_dec5(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_dec5(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_dec5(inputs)
	if (locale === "fil") return fil_misc_posts_dec5(inputs)
	if (locale === "fr") return fr_misc_posts_dec5(inputs)
	if (locale === "it") return it_misc_posts_dec5(inputs)
	if (locale === "hu") return hu_misc_posts_dec5(inputs)
	if (locale === "nl") return nl_misc_posts_dec5(inputs)
	if (locale === "no") return no_misc_posts_dec5(inputs)
	if (locale === "pl") return pl_misc_posts_dec5(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_dec5(inputs)
	if (locale === "pt") return pt_misc_posts_dec5(inputs)
	if (locale === "ro") return ro_misc_posts_dec5(inputs)
	if (locale === "fi") return fi_misc_posts_dec5(inputs)
	if (locale === "sv") return sv_misc_posts_dec5(inputs)
	if (locale === "vi") return vi_misc_posts_dec5(inputs)
	if (locale === "tr") return tr_misc_posts_dec5(inputs)
	if (locale === "cs") return cs_misc_posts_dec5(inputs)
	if (locale === "bg") return bg_misc_posts_dec5(inputs)
	if (locale === "ru") return ru_misc_posts_dec5(inputs)
	if (locale === "uk") return uk_misc_posts_dec5(inputs)
	if (locale === "ar") return ar_misc_posts_dec5(inputs)
	if (locale === "hi") return hi_misc_posts_dec5(inputs)
	if (locale === "th") return th_misc_posts_dec5(inputs)
	if (locale === "ja") return ja_misc_posts_dec5(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_dec5(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_dec5(inputs)
	return ko_misc_posts_dec5(inputs)
});
export { misc_posts_dec5 as "misc.posts.dec5" }